import styled, { createGlobalStyle, css } from "styled-components";
import {StoreButtonBase} from "@widgets/profile/ui/styled";

export const StoryGlobalStyle = createGlobalStyle`
    :root {
        //color-scheme: dark;
        background-color: #15354d;
    }

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    html,
    body,
    #root {
        scroll-behavior: smooth;
        width: 100%;
        max-width: 100%;
        overflow-x: clip;
        overscroll-behavior-x: none;
    }

    html {
        //background: transparent;
        scrollbar-color: rgba(244, 240, 233, 0.28) transparent;
    }

    body {
        margin: 0;
        width: 100%;
        max-width: 100%;
        color: #f4f0e9;
        //font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
    }

    @supports not (overflow: clip) {
        html,
        body,
        #root {
            overflow-x: hidden;
        }
    }

    @media (max-width: 899px) {
        /* Основная мобильная шапка из layout должна быть привязана к viewport. */
        #root > div > header {
            width: 100%;
            max-width: 100%;
            //padding-right: max(64px, calc(20px + env(safe-area-inset-right)));
            //padding-left: max(25px, env(safe-area-inset-left));
            box-sizing: border-box;
        }

        #root > div > button:first-of-type {
            right: max(25px, env(safe-area-inset-right));
        }

        /* Панель бургер-меню не может стать шире мобильного viewport. */
        #navbar-multi-level {
            position: fixed;
            top: calc(68px + env(safe-area-inset-top));
            right: max(20px, env(safe-area-inset-right));
            left: auto;
            width: min(280px, calc(100vw - 40px));
            max-width: calc(100vw - 40px);
            overflow-x: hidden;
        }
    }

    html::-webkit-scrollbar,
    body::-webkit-scrollbar {
        width: 8px;
    }

    html::-webkit-scrollbar-track,
    body::-webkit-scrollbar-track {
        background: transparent;
    }

    html::-webkit-scrollbar-thumb,
    body::-webkit-scrollbar-thumb {
        border: 2px solid transparent;
        border-radius: 999px;
        background: rgba(244, 240, 233, 0.28);
        background-clip: padding-box;
    }

    button,
    a {
        font: inherit;
    }

    @media (prefers-reduced-motion: reduce) {
        html {
            scroll-behavior: auto;
        }
    }
`;

export const Grain = styled.div`
    position: fixed;
    inset: 0;
    z-index: 20;
    pointer-events: none;
    opacity: 0.035;
    //background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 220 220' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.86' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.8'/%3E%3C/svg%3E");
    mix-blend-mode: soft-light;

    @media (prefers-reduced-motion: reduce) {
        display: none;
    }
`;

export const Header = styled.header`
    position: fixed;
    z-index: 30;
    top: 0;
    right: 0;
    left: 0;
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    min-height: 88px;
    padding: env(safe-area-inset-top) clamp(22px, 4vw, 72px) 0;
    //border-bottom: 1px solid rgba(244, 240, 233, 0.12);
    transition:
            background 0.5s cubic-bezier(0.2, 0.72, 0.2, 1),
            border-color 0.5s cubic-bezier(0.2, 0.72, 0.2, 1);

    &.is-open {
        //border-color: rgba(244, 240, 233, 0.18);
        //background: rgba(13, 38, 57, 0.34);
        //backdrop-filter: blur(12px);
        //-webkit-backdrop-filter: blur(12px);
    }

    @media (max-width: 900px) {
        grid-template-columns: 1fr auto;
        min-height: calc(72px + env(safe-area-inset-top));
        padding: env(safe-area-inset-top) 20px 0;
    }

    @media (max-width: 420px) {
        padding-inline: 16px;
    }

    @media (orientation: landscape) and (max-height: 560px) {
        min-height: calc(58px + env(safe-area-inset-top));
    }

    @media (max-width: 900px) and (orientation: portrait) {
        min-height: calc(68px + env(safe-area-inset-top));
        padding: env(safe-area-inset-top) 28px 0;
        border-bottom: 0;
        background: transparent;
        backdrop-filter: none;
        -webkit-backdrop-filter: none;

        &.is-open {
            border-bottom: 0;
            background: transparent;
            backdrop-filter: none;
            -webkit-backdrop-filter: none;
        }
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        padding-inline: 24px;
    }
`;

export const Brand = styled.a`
    justify-self: start;
    color: #f4f0e9;
    font-family: "Iowan Old Style", Baskerville, Georgia, serif;
    font-size: 29px;
    line-height: 1;
    letter-spacing: -0.03em;
    text-decoration: none;

    @media (max-width: 420px) {
        font-size: 25px;
    }
`;

export const Nav = styled.nav`
    display: flex;
    align-items: center;
    gap: clamp(24px, 3vw, 52px);

    a {
        color: inherit;
        font-size: 10px;
        line-height: 1;
        letter-spacing: 0.18em;
        text-decoration: none;
        text-transform: uppercase;
        opacity: 0.74;
        transition: opacity 0.25s ease;
    }

    a:hover,
    a:focus-visible {
        opacity: 1;
    }

    @media (max-width: 900px) {
        display: none;
    }
`;

export const HeaderActions = styled.div`
    justify-self: end;
    display: flex;
    align-items: center;
    gap: 28px;

    @media (max-width: 900px) and (orientation: portrait) {
        display: none;
    }
`;

export const InviteLink = styled.a`
    color: inherit;
    font-size: 10px;
    line-height: 1;
    letter-spacing: 0.18em;
    text-decoration: none;
    text-transform: uppercase;
    opacity: 0.74;
    transition: opacity 0.25s ease;

    &:hover,
    &:focus-visible {
        opacity: 1;
    }

    @media (max-width: 900px) {
        display: none;
    }
`;

export const Main = styled.main`
    position: relative;
    display: block;
    width: 100%;
    min-width: 0;
    //overflow-x: clip;
    color: #f4f0e9;
    background: transparent;
`;

export const Story = styled.section`
    position: relative;
    width: 100%;
    height: 520vh;
    height: 520svh;
    //overflow-x: clip;
    background: transparent;
    margin-top: -10vh;

    @media (max-width: 900px) and (orientation: portrait) {
        height: 500vh;
        height: 500svh;
    }
`;

export const Stage = styled.div`
    position: sticky;
    top: 0;
    isolation: isolate;
    width: 100%;
    height: 100vh;
    height: 100svh;
    height: var(--stage-height, 100dvh);
    min-height: 620px;
    overflow: visible;
    padding: 0;
    background: transparent;

    &::before {
        content: "";
        position: absolute;

        /* Свет выше Stage, но его ширина ровно равна viewport. */
        top: -25vh;
        bottom: -25vh;
        left: 50%;
        width: 100vw;
        max-width: 100vw;
        transform: translateX(-50%);

        /* Выше основного фона, но ниже контента слайдера */
        z-index: 0;
        pointer-events: none;

        background: radial-gradient(
                ellipse 48% 62% at var(--glow-x, 72%) 42%,
                rgba(255, 255, 255, 0.15) 0%,
                rgba(255, 255, 255, 0.06) 34%,
                rgba(255, 255, 255, 0.02) 52%,
                transparent 74%
        );
    }

    @media (max-width: 900px) {
        min-height: 0;
    }

    @media (max-width: 900px) and (orientation: portrait) {
        height: var(--stage-height, 100svh);
        padding: 0;
    }
`;

export const Copy = styled.div`
    position: absolute;
    z-index: 8;
    top: 50%;
    //left: clamp(22px, 8vw, 140px);
    width: min(540px, 42vw);
    transform: translateY(-50%);

    @media (max-width: 900px) {
        top: 56%;
        right: 22px;
        left: 22px;
        width: auto;
        transform: none;
    }

    @media (max-width: 420px) {
        right: 30px;
        left: 18px;
    }

    @media (max-height: 700px) and (max-width: 900px) {
        top: 48%;
    }

    @media (orientation: landscape) and (max-height: 560px) {
        top: 54%;
        right: auto;
        left: max(24px, env(safe-area-inset-left));
        width: 43vw;
        transform: translateY(-50%);
    }

    @media (max-width: 900px) and (orientation: portrait) {
        top: auto;
        right: 34px;
        bottom: calc(9dvh + 28px + env(safe-area-inset-bottom));
        left: 34px;
        width: auto;
        height: min(48svh, 390px);
        transform: none;
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        right: 28px;
        bottom: calc(8dvh + 24px + env(safe-area-inset-bottom));
        left: 28px;
        height: min(54svh, 350px);
    }
`;

export const CopyFrame = styled.article`
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    opacity: var(--copy-o, 0);
    transform: translateY(calc(-50% + var(--copy-y, 18px)));
    transition: none;
    pointer-events: none;

    &.is-active {
        pointer-events: auto;
    }

    @media (max-width: 900px) {
        top: 0;
        bottom: auto;
        transform: translateY(var(--copy-y, 18px));
        left: -14px;
        top: 22vh;
    }

    @media (orientation: landscape) and (max-height: 560px) {
        top: 50%;
        bottom: auto;
        transform: translateY(calc(-50% + var(--copy-y, 18px)));
    }

    @media (max-width: 900px) and (orientation: portrait) {
        top: auto;
        bottom: 0;
        transform: translateY(var(--copy-y, 18px));
        left: -14px;
        top: 22vh;
    }
`;

export const Eyebrow = styled.p`
    margin: 0 0 26px;
    color: #c28f5a;
    font-size: 10px;
    line-height: 1.5;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    text-align: left;
    padding-left: 2px;

    @media (max-width: 560px) {
        max-width: 300px;
        margin-bottom: 18px;
        font-size: 8px;
    }

    @media (max-height: 700px) and (max-width: 900px) {
        margin-bottom: 13px;
    }

    @media (max-width: 900px) and (orientation: portrait) {
        max-width: none;
        margin-bottom: 14px;
        color: #e4ba89;
        font-size: 8px;
        text-align: left;
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        margin-bottom: 10px;
    }
`;

const headingStyles = css`
    margin: 0;
    //font-family: "Iowan Old Style", Baskerville, Georgia, serif;
    font-weight: 400;
    letter-spacing: -0.035em;
    text-wrap: balance;
    text-align: left;
`;

export const HeroTitle = styled.h1`
    ${headingStyles}
    max-width: 570px;
    //font-size: clamp(54px, 6vw, 96px);
    line-height: 1.15;

    @media (max-width: 900px) {
        font-size: clamp(44px, 9vw, 64px);
    }

    @media (max-width: 560px) {
        font-size: clamp(40px, 11.5vw, 52px);
    }

    @media (max-height: 700px) and (max-width: 900px) {
        font-size: clamp(38px, 10vw, 48px);
    }

    @media (orientation: landscape) and (max-height: 560px) {
        font-size: clamp(38px, 6.5vw, 58px);
    }

    @media (max-width: 900px) and (orientation: portrait) {
        max-width: 330px;
        font-size: clamp(39px, 8.5vw, 52px);
        line-height: 0.96;
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        font-size: clamp(36px, 10.8vw, 44px);
    }
`;

export const StoryTitle = styled.h2`
    ${headingStyles}
    max-width: 520px;
    font-size: clamp(37px, 1vw, 77px);
    line-height: 1;
    text-align: left;

    @media (max-width: 900px) {
        font-size: clamp(38px, 8vw, 56px);
    }

    @media (max-width: 560px) {
        font-size: clamp(36px, 10vw, 46px);
    }

    @media (max-height: 700px) and (max-width: 900px) {
        font-size: clamp(34px, 8.5vw, 43px);
    }

    @media (orientation: landscape) and (max-height: 560px) {
        font-size: clamp(34px, 5.5vw, 48px);
    }

    @media (max-width: 900px) and (orientation: portrait) {
        max-width: 335px;
        font-size: clamp(22px, 3.5vw, 29px);
        line-height: 0.98;
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        font-size: clamp(33px, 9.8vw, 41px);
    }
`;

export const Lead = styled.p`
    max-width: 450px;
    margin: 28px 0 0;
    font-size: clamp(14px, 1.15vw, 18px);
    line-height: 1.55;
    opacity: 0.72;
    text-align: left;
    font-family: "Montserrat", sans-serif;

    @media (max-width: 900px) {
        max-width: 420px;
        font-size: 14px;
    }

    @media (max-width: 560px) {
        margin-top: 18px;
        line-height: 1.45;
    }

    @media (max-height: 700px) and (max-width: 900px) {
        margin-top: 13px;
        font-size: 12px;
    }

    @media (orientation: landscape) and (max-height: 560px) {
        max-width: 38vw;
    }

    @media (max-width: 900px) and (orientation: portrait) {
        max-width: 330px;
        margin-top: 16px;
        font-size: 13px;
        line-height: 1.45;
        opacity: 0.82;
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        margin-top: 12px;
        font-size: 12px;
    }
`;

export const HeroActions = styled.div`
    display: flex;
    align-items: center;
    gap: 26px;
    margin-top: 36px;

    @media (max-width: 900px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 18px;
    }

    @media (max-width: 560px) {
        margin-top: 24px;
    }

    @media (max-height: 700px) and (max-width: 900px) {
        gap: 12px;
        margin-top: 16px;
    }

    @media (max-width: 900px) and (orientation: portrait) {
        margin-top: 22px;
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        margin-top: 16px;
    }
`;

export const ScrollNote = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 10px;
    letter-spacing: 0.12em;
    opacity: 0.5;

    //&::before {
    //    content: "↓";
    //    font-size: 17px;
    //    line-height: 1;
    //}

    @media (max-width: 900px) {
        display: none;
    }
`;

export const Portal = styled.figure`
    position: absolute;
    z-index: 4;
    top: 50%;
    left: 50%;
    width: var(--portal-w, 2px);
    height: var(--portal-h, 58vh);
    //margin: 0;
    overflow: hidden;
    isolation: isolate;
    //border: 1px solid rgba(244, 240, 233, var(--portal-border, 0.35));
    border-radius: var(--portal-r, 999px);
    background: transparent;
    //box-shadow: 0 28px 100px rgba(4, 18, 28, var(--portal-shadow, 0));
    transform: translate(var(--portal-x, -50%), -50%);
    will-change: width, height, transform, border-radius;

    &::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 3;
        pointer-events: none;
        background: rgba(6, 23, 35, 0.1);
    }

    @media (max-width: 900px) and (orientation: portrait) {
        top: 50% !important;
        left: 50%;
        width: var(--portal-w, 2px);
        height: var(--portal-h, 62vh);
        border-color: rgba(244, 240, 233, 0.18);
        border-radius: var(--portal-r, 999px);
        //box-shadow: 0 22px 70px rgba(4, 18, 28, 0.28);
        transform: translate(var(--portal-x, -50%), -50%);

        &::after {
            background: rgba(5, 20, 31, 0.18);
        }
    }
    
    @media (min-width: 1024px) {
        left: 45%;
    }
`;

export const PortalPicture = styled.picture`
  position: absolute;
  inset: 0;
  display: block;
`;

export const PortalImage = styled.img<{ $objectPosition: string }>`
    position: absolute;
    inset: -2%;
    width: 104%;
    height: 104%;
    object-fit: cover;
    object-position: ${({ $objectPosition }) => $objectPosition};
    opacity: var(--photo-o, 0);
    filter: saturate(0.82) contrast(1.03);
    transform: scale(var(--photo-scale, 1.04));
    transition: none;
    will-change: opacity, transform;

    @media (max-width: 900px) and (orientation: portrait) {
        inset: -1px;
        width: calc(100% + 2px);
        height: calc(100% + 2px);
        object-position: center center;
    }
`;

export const ChapterMarks = styled.div`
    position: absolute;
    z-index: 7;
    top: 50%;
    right: clamp(22px, 4vw, 72px);
    display: grid;
    gap: 10px;
    transform: translateY(-50%);

    span {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: rgba(244, 240, 233, 0.25);
        transition:
                height 0.3s ease,
                border-radius 0.3s ease,
                background 0.3s ease;
    }

    span.is-active {
        height: 34px;
        border-radius: 3px;
        background: #c28f5a;
    }

    @media (max-width: 900px) {
        right: 16px;
    }

    @media (max-width: 900px) and (orientation: portrait) {
        display: none;
    }
`;

export const Edition = styled.div`
    position: absolute;
    z-index: 5;
    bottom: 34px;
    left: clamp(22px, 4vw, 72px);
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 9px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    opacity: 0.5;

    &::before {
        content: "";
        width: 30px;
        height: 1px;
        background: currentColor;
    }

    @media (max-width: 900px) {
        display: none;
    }
`;

export const Progress = styled.div`
    position: absolute;
    z-index: 9;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    background: rgba(244, 240, 233, 0.1);

    @media (max-width: 900px) and (orientation: portrait) {
        right: 0;
        bottom: 0;
        left: 0;
        height: 1px;
        overflow: hidden;
        border-radius: 1px;
    }
`;

export const ProgressBar = styled.div`
    width: var(--progress, 0%);
    height: 100%;
    //background: #c28f5a;
    transform-origin: left center;
`;

export const AfterStory = styled.section`
    display: grid;
    place-items: center;
    min-height: 100vh;
    min-height: 100svh;
    padding: 140px 24px;
    text-align: center;
    background: transparent;

    p {
        max-width: 780px;
        margin: 0;
        font-family: "Iowan Old Style", Baskerville, Georgia, serif;
        font-size: clamp(44px, 6vw, 92px);
        line-height: 1;
        letter-spacing: -0.04em;
    }

    @media (max-width: 900px) {
        padding-inline: 22px;
    }
`;

export const AppleIcon = styled.svg`
    width: 27px;
    height: 27px;
    flex: 0 0 auto;
    fill: currentColor;
`;

export const StoreText = styled.span`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
`;

export const StoreTextSmall = styled.span`
    font-size: 9px;
    line-height: 1.05;
    letter-spacing: 0.03em;
    opacity: 0.72;
`;

export const StoreTextStrong = styled.span`
    margin-top: 2px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: -0.01em;
    white-space: nowrap;
`;

export const StoreButton = styled.a<{ $variant: "header" | "hero" }>`
    border: none;
    background: rgba(255, 255, 255, 0.1); /* Полупрозрачный белый фон */
    backdrop-filter: blur(20px); /* Размытие того, что находится позади блока */
    -webkit-backdrop-filter: blur(20px); /* Для поддержки Safari */
    border: 1px solid rgba(255, 255, 255, 0.3); /* Тонкая полупрозрачная рамка */
    border-radius: 20px; /* Скругленные углы, как у Apple */
    //box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37); /* Мягкая тень */

    &:hover {
        filter: brightness(1.05);
    }
    margin-top: -2px;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #feffff;

    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 11px;
    min-height: 58px;
    padding: 7px 24px;
    //border: 1px solid rgba(194, 143, 90, 0.88);
    //border-radius: 0;
    //color: #102d42;
    //background: #c28f5a;
    text-decoration: none;
    transition:
            transform 0.25s ease,
            filter 0.25s ease,
            color 0.25s ease,
            background 0.25s ease;

    &:hover {
        filter: brightness(1.08);
        transform: translateY(-2px);
    }

    &:focus-visible {
        outline: 2px solid #e4ba89;
        outline-offset: 4px;
    }

    ${({ $variant }) =>
            $variant === "header" &&
            css`
                min-height: 48px;
                gap: 9px;
                padding: 6px 17px;
                border-color: rgba(194, 143, 90, 0.72);
                color: #f4f0e9;
                background: transparent;

                ${AppleIcon} {
                    width: 23px;
                    height: 23px;
                }

                ${StoreTextSmall} {
                    font-size: 8px;
                }

                ${StoreTextStrong} {
                    font-size: 15px;
                }

                &:hover {
                    color: #122c45;
                    background: #c28f5a;
                    filter: none;
                    transform: none;
                }
            `}

    @media (max-width: 900px) {
    ${({ $variant }) =>
            $variant === "header" &&
            css`
                min-height: 43px;
                padding: 5px 13px;

                ${AppleIcon} {
                    width: 20px;
                    height: 20px;
                }

                ${StoreTextSmall} {
                    font-size: 7px;
                }

                ${StoreTextStrong} {
                    font-size: 13px;
                }
            `}
}

    @media (max-width: 560px) {
        ${({ $variant }) =>
                $variant === "hero" &&
                css`
                    min-height: 52px;
                    padding: 6px 20px;
                `}
    }

    @media (max-height: 700px) and (max-width: 900px) {
        ${({ $variant }) =>
                $variant === "hero" &&
                css`
                    min-height: 40px;
                `}
    }

    @media (max-width: 420px) {
        ${({ $variant }) =>
                $variant === "header" &&
                css`
                    min-height: 38px;
                    gap: 7px;
                    padding: 5px 10px;

                    ${StoreTextSmall} {
                        display: none;
                    }

                    ${StoreTextStrong} {
                        margin: 0;
                        font-size: 12px;
                    }

                    ${AppleIcon} {
                        width: 18px;
                        height: 18px;
                    }
                `}
    }

    @media (max-width: 900px) and (orientation: portrait) {
        ${({ $variant }) =>
                $variant === "hero" &&
                css`
                    min-height: 50px;
                    padding: 6px 18px;
                `}
    }

    @media (max-width: 380px) and (orientation: portrait),
    (max-height: 680px) and (orientation: portrait) {
        ${({ $variant }) =>
                $variant === "hero" &&
                css`
                    min-height: 46px;
                `}
    }
`;
